import React, { Component } from 'react';
//import { connect } from 'react-redux';
import { observer } from 'mobx-react';
//import { toJS } from 'mobx';
import { createViewModel } from 'mobx-utils';
import { Button, CircularProgress, TextField,
         Typography, Tooltip, Checkbox, FormControlLabel,
         Box, Paper,
         Dialog, DialogTitle, DialogContent, DialogActions,
         Table, TableRow, TableCell, TableHead, TableBody } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { CheckCircle, Error  } from '@mui/icons-material';

import { Navigate } from 'react-router';
import _ from 'lodash';
import styled from 'styled-components';

import QuickEditDialog from './QuickEditDialog';
import Header from './Header';
import { Error as FlowError } from './Error';
import { AppStates } from './FlowStore';
//import { validateEmail, clientIDValidate } from './FlowAdmin';

const toolTipDelay = 1000;

const PageContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  margin: 20;
  align-items: center;
`;

//width:100vw;

const LeftDialogDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: top;
`;

const Text = styled.div`
  padding-top: 1.25em;
  font-weight: bold;
`;

const RefResult = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5em;
`

const showSummaryDocTypes =
      ['PAT.NFOA', 'PAT.FOA', 'PAT.NotCAP', 'PAT.NotMP', 'PAT.RR', 'PAT.NotRC', 'PCT.WOSA'];

@observer
class GenerateDocuments extends Component {
  constructor(props) {
    super(props);
    this.store = props.store;
    console.log('Gen Constructor');
    this.state = {
      fetchReferences: this.store.rejections.length > 0,
      templates: this.store.getTemplates(),
      clientEditDisabled: !this.store.isClientSelected(),
      clientValue: null,
      client: null,
    };
    //console.log(this.state.templates);
  }

  componentDidMount() {
    if (!this.state.client && this.store.client) {
      //this.setState(() => ({client: createViewModel(this.store.availableClients[this.store.client])}));
      this.setState(() => ({client: this.store.availableClients[this.store.client]}));
    }
  }
  
  componentDidUpdate = () => {
    //console.log('Mounting gen');
    if (this.state.fetchReferences == null) {
      //this.setState({fetchReferences: this.store.rejections.length > 0,
      //               templates: this.store.getTemplates()});
    }
  }

  isTemplateChecked = (name) => {
    //console.log('checked?', name, this.state.templates.includes(name));
    return this.state.templates.includes(name);
  }

  handleTemplateSelection = event => {
    let template = event.target.name;
    console.log('Templates selection', template, this.state.templates);
    this.setState(prevState => ({
      templates: _.xor([...prevState.templates], [template])
    })); 
    console.log('Templates selected', this.state.templates);
  };
  
  handleReferencesSelection = () => {
    this.setState(prevState => ({fetchReferences: !prevState.fetchReferences}));
  };
  //checked={this.state.selectedDocs.templates.includes(template)}
  
  showTemplates = () => {
    //console.log(this.store.getTemplates());
    //console.log(this.state.templates);
    return this.store.getTemplates().map(
      (template, index) => {
        return (
          <Box key={'tpl.'+index} m={0} paddingLeft={2}>
            <FormControlLabel 
              label={<Typography variant='body2' >
                     {template}</Typography>}
              key={`${template}-${index}`}
              control={
                <Checkbox
                  color='primary'
                  size='small'
                  checked={this.isTemplateChecked(template)} 
                  onChange={this.handleTemplateSelection}
                  name={template}
                />
              }
            />
            </Box>
        );
      } 
    );
  };
  
  renderDialogContent = () => {
    if (false) { // fixme: this.props.doc.errorGettingResults) {
      return (
        <Dialog
          open={true}
        >
          <DialogTitle>
            Error
          </DialogTitle>
          <DialogContent>
            Sorry, we've encountered technical difficulties.  Please try ...
          </DialogContent>
          <DialogActions>
              <Button
                variant='contained'
                disableElevation
                margin='dense'
                onClick={() => {
                  console.log('Go home');
                  this.store.appState = AppStates.DASHBOARD;
                }}>
                Home
              </Button>
          </DialogActions>
        </Dialog>
      );
    }
    
    // If we are not in progress (awaitingResults) or complete (resultsURL != null)
    if (this.store.resultsURL === null && !this.store.awaitingResults) {
      //console.log('Generating the main dialog');
      return (
        <div>
          {showSummaryDocTypes.includes(this.store.docType) ? (
            <Text>
              <Typography variant='body1' style={{fontWeight:450, maxWidth:'800px'}}>
                1. Your generated documents will include the following
                {' ' + this.store.rejections.length + ' '}
                issues we found in the {this.store.docTypes[this.store.docType]}:
              </Typography>
              <Paper variant='outlined' style={{marginTop: 10}}>
                <Table size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell style={{width:'100px', fontWeight: 'bold'}}>Issue</TableCell>
                    <TableCell style={{width:'250px', fontWeight: 'bold'}}>Claims/Notes</TableCell>
                    <TableCell style={{fontWeight: 'bold'}}>References</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.store.rejections.map((rejection, index) => {
                    return (
		      <TableRow key={index} className='red'>
                        <TableCell>{rejection.basis}</TableCell>
                        <TableCell>{rejection.claims}</TableCell>
                        <TableCell style={{ whiteSpace: 'pre' }}>
                          {rejection
                           .references
			   .map(reference => {
			     return `${reference.country}-${reference.num}`;
                           })
			   .join('\n')}
                        </TableCell>
		      </TableRow>
                    );
                  })}
                </TableBody>
                </Table>
              </Paper>
            </Text>
           ) : (
             <Typography variant='body1' style={{maxWidth:"800px"}}>
               1. We'll create shell documents for the {' '}
               {this.store.docTypes[this.store.docType]} received from
               the Office. 
             </Typography>
           )}
          <Typography variant='body1' style={{marginTop: '1em'}}>
            2. Please select the client:
          </Typography>
          <div style={{display: 'flex', alignItems:'flex-end'}}>
            <Autocomplete
              size='small'
              id='client-selection'
              style={{width:'500px', marginRight: 10}}
              key={this.state.clientValue}
              options={Object.values(this.store.availableClients)}
              value={this.store.isClientSelected() ? this.store.availableClients[this.store.client] : null}
              getOptionLabel={(o) => {
                return o ? o.id + ': ' + o.name : 'Select Client';
              }}
              onChange={(e, newValue) => {
                if (newValue) {
                  console.log('Selecting client', newValue.id);
                  this.store.setClient(newValue.id);
                  //this.setState(() => ({clientEditDisabled: false, client: createViewModel(newValue)}));
                  this.setState(() => ({clientEditDisabled: false, client: newValue}));
                }
              }}
              renderInput={(params) =>
                           <TextField {...params} style={{marginBottom:0}}
                                      label='Select Client' variant='outlined'
                                      size='small' margin='dense'/>
                          }
            />
            <QuickEditDialog
              title={"Edit/View Client " + this.store.client}
              record={this.state.client}
              fields={['id', 'name', 'contact', 'street1', 'city_state_zip', 'email', 'cc1']}
              getFieldLabel={(field) => this.store.clientAttributeNames[field]}
              onSave={(record) => {
                console.log('Setting client info!' + JSON.stringify(record));
                // FIXME, we no longer do this because availableClients is no longer observable
                // as that does not scale when the client list grows
                //if (!record.isDirty) {
                //  console.log('Client not dirty');
                //  return;
                //}
                //let newClient = {...this.store.availableClients[this.store.client]};
                //for (var k in newClient)
                //  newClient[k] = record[k];
                let newClient = record;
                this.store.updateClients(newClient);
                this.store.setClient(newClient.id);
                this.setState(() => ({clientValue: record.id + ': ' + record.name}));
              }}
              disabled={this.state.clientEditDisabled}
            />
            {/* <NavLink to={"/admin#/clients/" + this.store.client}>
              <Button variant='outlined'>Edit</Button>
              </NavLink>*/}
          </div>

          <Typography style={{marginTop: "1em"}}>
            3. Please select from the following documents:
          </Typography>
          <div style={{fontSize: "10px"}}>
            {Object.keys(this.store.templates).length > 0 &&
             this.store.docType &&
             this.showTemplates()}
            {this.store.hasReferences() ?
             <Box m={0} paddingLeft={2}>
               <FormControlLabel
                 m={0}
                 label={
                   <Typography variant='body2'>
                     Include references (only US/WO Patent documents currently)
                   </Typography>}
                 control={
                   <Checkbox
                     color='primary'
                     size='small'
                     checked={this.state.fetchReferences}
                     onChange={() => {this.handleReferencesSelection()}}
                   />
                 }
               />
             </Box>:<span/>}
          </div>
          
          <div style={{marginTop: '1em'}}>
            <Button
              style={{marginRight: '20px'}}
              variant='contained'
              disableElevation
              onClick={() => {
                this.store.appState = AppStates.REVIEW;
              }}
            >
              Cancel/Keep Editing
            </Button>
            <Tooltip
	      title="Please select client first"
	      enterDelay={toolTipDelay}
	      disableHoverListener={this.store.isClientSelected()} 
	      disableFocusListener={this.store.isClientSelected()} >
              <Button
                variant='contained'
                disableElevation
                color='primary'
	        disabled={!this.store.isClientSelected()}
                onClick={() => {
                  this.store.getResults(
                    this.state.fetchReferences,
                    this.state.templates
                  );
                  //this.setState(() => ({ gettingDocuments: true }));
                }}
	      >
                Create Documents
              </Button>
	    </Tooltip>
          </div>
        </div>
      );
    }

    // If we waiting for the server to to finish processing
    else if (this.store.awaitingResults) {
      return (
        <LeftDialogDiv className="bp3-dialog-body">
          <div><CircularProgress /></div>
          {this.refsFetched()}
        </LeftDialogDiv>
      );
    }

    // Server is done and we have received the magic URL
    else {
      console.log(this.store.resultsURL);
      return (
        <LeftDialogDiv className="bp3-dialog-body">
          <a href={this.store.resultsURL}>
            <Button
              variant='contained'
              disableElevation
              margin='dense'
              color='primary'
              onClick={() => {
                console.log('Providing results');
                this.store.appState = AppStates.DASHBOARD;
                this.store.resetGettingResults();
                this.store.resetWorkspace('');
              }}
            >
              Download!
            </Button>
          </a>
          {this.refsFetched()}
        </LeftDialogDiv>
      );
    }
  };
    
  refsFetched() {
    return (
      <div style={{marginLeft: '20px', display: 'flex'}}>
        {this.store.rejections.length === 0 ?
         <p>No references to fetch</p>
         :
         <div>
           <RefResult style={{fontWeight:'bold'}}>
             Status of cited references:
           </RefResult>
           {this.store.getFetchRefEvents().map((evt, index) => {
             return (
               <RefResult key={evt.ref.num}>
                 {evt.status === 'OK' ?
                  <CheckCircle fontSize='small' style={{color: 'green'}}/>
                  :
                  <Error fontSize='small' style={{color:'red'}} />
                 }
                 {evt.ref.country}{evt.ref.num} 
               </RefResult>
             );
           })}
         </div>
        }
      </div>);
  }
    
  render() {
    try {
      if (this.store.appState === AppStates.DASHBOARD) {
        return <Navigate to="/dashboard" />;
      }

      if (this.store.appState === AppStates.REVIEW) {
        return <Navigate to="/review" />;
      }

      return (
        <div>
          <Header store={this.store}/>
          <PageContainerDiv>
            <Typography style={{marginTop: "20px", marginBottom: 20}} variant='h5'>
              {
                !this.store.resultsURL
                  ? 'Generate Form Documents'
                  : 'Your Documents Are Ready!'
              }
            </Typography>
            {this.renderDialogContent()}
          </PageContainerDiv>
        </div>
      );
    }
    catch (e) {
      console.log('Caught error in GenerateDocuments.render', e);
      return (
        <div>
          <Header store={this.store}/>
          <FlowError msg='Error while generating documents'
                     error={e}
                     store={this.store}/>
        </div>
      );
    }
  }
}

export default GenerateDocuments;

